import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Welcome from './pages/Welcome';
import Quiz from './pages/Quiz';
import Result from './pages/Result';
import GuestQuiz from './pages/GuestQuiz';
import GuestResult from './pages/GuestResult';
import AdminLogin from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import Colleges from './pages/admin/Colleges';
import Assign from './pages/admin/Assign';
import Export from './pages/admin/Export';
import Questions from './pages/admin/Questions';
import Roster from './pages/admin/Roster';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/result/:userId" element={<Result />} />
        <Route path="/guest-quiz" element={<GuestQuiz />} />
        <Route path="/guest-result" element={<GuestResult />} />
        <Route path="/admin" element={<Navigate to="/admin/login" />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/colleges" element={<Colleges />} />
        <Route path="/admin/assign" element={<Assign />} />
        <Route path="/admin/export" element={<Export />} />
        <Route path="/admin/questions" element={<Questions />} />
        <Route path="/admin/roster" element={<Roster />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
